"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaAlterMateria = exports.schemaGrade = exports.yupGrade = void 0;
const yup = __importStar(require("yup"));
// import { ICurso } from './curso';
// import { ISerie } from './serie';
exports.yupGrade = yup.object({
    idCurso: yup.number().required().positive().integer().label('Curso'),
    idSerie: yup.number().required().positive().integer().label('Série'),
    idMateria: yup.number().required().positive().integer().label('Matéria'),
    sequencia: yup.string().max(3).default('').label('Sequência'),
    naoImprimirNotaFicha: yup.boolean().required().default(false).label('Ocultar Nota na Ficha Individual'),
    imprimirFicha: yup.boolean().required().default(false).label('Imprimir Nota na Ficha Individual'),
    imprimirHistorico: yup.boolean().required().default(false).label('Imprimir Nota no Histórico Escolar'),
    imprimirBoletim: yup.boolean().required().default(false).label('Imprimir Nota no Boletim'),
    imprimirMencao: yup.boolean().required().default(false).label('Imprimir Nota como Menção'),
    // bimestre1: yup.number().required().label('Bimestre 1'),
    // bimestre2: yup.number().required().label('Bimestre 2'),
    // bimestre3: yup.number().required().label('Bimestre 3'),
    // bimestre4: yup.number().required().label('Bimestre 4'),
    // tipos: yup.string().max(15).label('Tipos'),
    professorAuxiliar: yup.boolean().required().default(false).label('Professor Auxiliar'),
    naoCalcularSub: yup.boolean().required().default(false).label('Não Calcular Medias da SubMateria'),
    naoCalcularMedia: yup.boolean().required().default(false).label('Não Calcular Medias para a Matéria'),
    calcularFalta: yup.boolean().required().default(false).label('Calcular Faltas somente para a Matéria'),
    naoCalcularFrequencia: yup.boolean().required().default(false).label('Não Calcular Frequência para a Matéria'),
});
exports.schemaGrade = exports.yupGrade.shape({});
const validateTypeField = (value) => {
    if (typeof value === 'string' && value.length === 3) {
        return true;
    }
    else if (typeof value === 'number' && value > 0) {
        return true;
    }
    return false;
};
exports.schemaAlterMateria = yup.object().shape({
    materiaOrigem: yup
        .mixed()
        .test('materiaOrigem', 'O campo matéria de origem deve ter 3 caracteres ou ser um número maior que zero', validateTypeField)
        .required()
        .label('Matéria de origem'),
    materiaDestino: yup
        .mixed()
        .test('materiaDestino', 'O campo matéria de destino deve ter 3 caracteres ou ser um número maior que zero', validateTypeField)
        .required()
        .label('Matéria de destino'),
    cursoGrade: yup
        .mixed()
        .test('cursoGrade', 'O campo curso deve ter 3 caracteres ou ser um número maior que zero', validateTypeField)
        .required()
        .label('Curso'),
    serieGrade: yup
        .mixed()
        .test('serieGrade', 'O campo série deve ser 1 caracter string de 1-9 ou um número maior que zero primary key', (value) => {
        if (typeof value === 'string' && value.trim().length === 1) {
            return /^[1-9]$/.test(value);
        }
        else if (typeof value === 'number' && value > 0) {
            return true;
        }
        return false;
    })
        .required()
        .label('Série'),
    anoLetivo: yup.string().required().label('Ano letivo'),
});
